import { EndPoint } from '@/enums/EndPoint'
import { ImportError } from '@/errors/ImportError'
import type { IImportDefinition } from '@/interfaces/IImportDefinition'
import { useI18n } from 'vue-i18n'
import { toBoolean, toIndex, toNumber, toText } from './'

export const getImportDefinition = (): IImportDefinition => {
  const i18n = useI18n({ useScope: 'global' })
  return {
    allowInsert: false,
    endpoint: EndPoint.CustomFields,
    keyFields: ['row'],
    friendlyName: 'tables.names.customFields',
    fields: [
      {
        title: i18n.t('fields.id'),
        name: 'row',
        convert: toIndex,
        required: true,
        aliases: ['id']
      },
      {
        title: i18n.t('fields.customFields.labelName'),
        name: 'labelName',
        convert: toText(20)
      },
      {
        title: i18n.t('fields.customFields.required'),
        name: 'required',
        convert: toNumber,
        defaultValue: 0
      },
      {
        title: i18n.t('fields.customFields.enabled'),
        name: 'enabled',
        convert: toNumber,
        defaultValue: 1
      },
      {
        title: i18n.t('fields.customFields.active'),
        name: 'active',
        convert: toNumber,
        defaultValue: 0
      },
      {
        title: i18n.t('fields.customFields.combo'),
        name: 'combo',
        convert: toNumber,
        defaultValue: 0
      },
      {
        title: i18n.t('fields.customFields.option0'),
        name: 'option0',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option1'),
        name: 'option1',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option2'),
        name: 'option2',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option3'),
        name: 'option3',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option4'),
        name: 'option4',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option5'),
        name: 'option5',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option6'),
        name: 'option6',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option7'),
        name: 'option7',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option8'),
        name: 'option8',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.option9'),
        name: 'option9',
        convert: toText(25)
      },
      {
        title: i18n.t('fields.customFields.autoComplete'),
        name: 'autoComplete',
        convert: toBoolean,
        defaultValue: true
      },
      {
        title: i18n.t('fields.customFields.allowFiltering'),
        name: 'allowFiltering',
        convert: toBoolean,
        defaultValue: true,
        aliases: ['Allow Program Status Filtering']
      }
    ],
    validate: (item: Record<string, any>) => {
      if (item.row === 0) {
        if (item.labelName !== 'Company') {
          throw new ImportError(i18n.t('errors.importTable.messages.invalidCompanyLabel'))
        }
        if (item.enabled === 1) {
          throw new ImportError(i18n.t('errors.importTable.messages.invalidCompanyStatus'))
        }
      }
      if (item.row === 1) {
        if (item.labelName !== 'Location') {
          throw new ImportError(i18n.t('errors.importTable.messages.invalidLocationLabel'))
        }
        if (item.enabled === 1) {
          throw new ImportError(i18n.t('errors.importTable.messages.invalidLocationStatus'))
        }
      }
      return true
    }
  }
}
